<div class="modal-header">
  @if(isLoading || !jobDetails ){
  <h4 class="modal-title">Job Eye View</h4>
  }@else{
  <h4 class="modal-title col-4">Order No. {{ jobDetails.orderNumber }}</h4>
    @if (jobStatus)
    {
      <span class="badge" [style]="{'background-color': jobStatus.colour}">{{jobStatus.name||''}}</span>
    }
  }
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">

  @if(isLoading || !jobDetails){
  <h4>
    Loading...
  </h4>
  }@else{
  <div class="eye-view-grid-wrapper">
    <app-job-detail-box [jobDetails]="jobDetails"></app-job-detail-box>
    <div>
      <app-job-from-location-details-box [fromJobAddress]="jobDetails.fromJobAddressSelection"
        [fromJobContact]="jobDetails.fromJobContact"></app-job-from-location-details-box>
      <app-job-to-location-details-box [toJobAddress]="jobDetails.toJobAddressSelection"
        [toJobContact]="jobDetails.toJobContact"></app-job-to-location-details-box>
    </div>
  </div>
  <div class="mt-3">
    <app-job-product-details-box [jobDetails]="jobDetails"
      [jobProducts]="jobDetails.jobProducts"></app-job-product-details-box>
  </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>